/* =====================================================================
   DEMO / MOCK DATA — NOT PRODUCTION
   Availability rules for the mock adapter ONLY. Bella Vita's real opening
   hours, closures and free/busy data will come from Odoo through the API
   layer. This logic lives here (behind the adapter) so no UI component
   ever hardwires availability behaviour.
   Mirrors the demo behaviour in design-v2:
     - Fridays closed
     - past days closed
     - roughly every 7th day "fully booked"
   ===================================================================== */

// Slot templates by daypart (matches design-v2 groups).
export const SLOT_TEMPLATE = [
  { group: 'morning',   times: ['10:00', '10:30', '11:00', '11:30'] },
  { group: 'afternoon', times: ['12:30', '13:00', '14:00', '15:30', '16:00'] },
  { group: 'evening',   times: ['17:00', '17:30', '18:00', '19:00', '20:00', '20:30'] },
];

function startOfToday() {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d;
}

// LOCKED: customer booking horizon — today .. today+6 (7 dates). Mirrors the
// server (`bellavita_booking.booking_window_days`, default 7).
export const BOOKING_WINDOW_DAYS = 7;

export function bookingWindow() {
  const first = startOfToday();
  const last = new Date(first);
  last.setDate(last.getDate() + BOOKING_WINDOW_DAYS - 1);
  const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  return { days: BOOKING_WINDOW_DAYS, firstDateISO: iso(first), lastDateISO: iso(last), tz: 'Asia/Riyadh' };
}

function inWindow(date) {
  const first = startOfToday();
  const last = new Date(first);
  last.setDate(last.getDate() + BOOKING_WINDOW_DAYS - 1);
  return date >= first && date <= last;
}

/** Is the salon open on this Date (demo rules + 7-day horizon)? */
export function isOpenDay(date) {
  if (!inWindow(date)) return false;
  if (date.getDay() === 5) return false; // Friday closed (demo)
  return true;
}

/** Does this open day still have slots (demo: every ~7th day is full)? */
export function dayHasSlots(date) {
  if (!isOpenDay(date)) return false;
  return date.getDate() % 7 !== 3;
}

/**
 * Slots for a given open day. Demo: mark one afternoon slot as taken so the
 * disabled-slot styling is exercised.
 * @returns {{group:string, time:string, available:boolean}[]}
 */
export function slotsForDay(date) {
  if (!dayHasSlots(date)) return [];
  const out = [];
  for (const { group, times } of SLOT_TEMPLATE) {
    times.forEach((time, i) => {
      const taken = group === 'afternoon' && i === 2;
      out.push({ group, time, available: !taken });
    });
  }
  return out;
}
